import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "./components/Portfolio";
import Admin from "./pages/Admin";
import ShortLinkRedirect from "./pages/ShortLinkRedirect";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/go/:slug" element={<ShortLinkRedirect />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;